export const AttendeeDetailsPageStyle = {
	wrapper: {
		position: 'relative',
		width: '100%',
		maxWidth: '1119px',
		display: 'flex',
		flexDirection: 'column',
		height: '100%',

		'@media (max-width: 639.98px)': {
			padding: '16px 20px 0',
		},
	},

	content: {
		display: 'flex',
		flexDirection: 'column',
		gap: '4px',
		alignItems: 'center',
		marginBottom: '24px',

		'& .MuiTypography-body1': {
			color: 'var(--neutral-300)',
		},
	},

	tabs: {
		background: 'var(--default-white)',
		borderRadius: '8px 8px 0 0',
		marginBottom: '40px',
		minHeight: '48px',

		'& .MuiTabs-flexContainer': {
			display: 'flex',
			width: '100%',
		},

		'@media (max-width: 767.98px)': {
			display: 'none',
		},
	},

	tab: {
		flex: 1,
		maxWidth: 'none',
		width: '100%',
		zIndex: 99,
		textTransform: 'none',
		fontWeight: 600,
	},

	attendeeDetails: {
		display: 'flex',
		flexDirection: 'column',
		gap: '20px',
		marginBottom: '24px',

		'@media (min-width: 768px)': {
			display: 'none',
		},
	},

	block: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		width: '100%',
	},

	text: {
		color: 'var(--neutral-300)',
	},

	description: {
		fontWeight: '700',
	},

	popup: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px',
		padding: '20px',
		height: '100%',

		'@media (min-width: 1200px)': {display: 'none'},
		'@media (max-width: 639.98px)': {
			display: 'none',
		},
	},

	buttonWrapper: {
		display: 'flex',
		gap: '16px',
		padding: '20px',
		height: '100%',
	},

	drawer: {
		'@media (min-width: 1200px)': {
			display: 'none',
		},
	},

	buttonCard: {
		'@media (min-width: 640px)': {
			display: 'none',
		},
	},

	modal: {
		'.MuiPaper-root': {
			maxWidth: '770px',
			padding: '48px 120px',
			width: '100%',

			'@media (max-width: 639.98px)': {
				padding: '40px 20px 20px',
			},
		},
	},
};
